import filter from 'lodash-es/filter'
import React, { useState } from 'react'

import { Table } from '@fourthwall/components'

import { SelectModal } from '../../../../../../../components/modals/SelectModal/SelectModal'
import type { Series } from '../../../../types'
import { useSeries } from '../../hooks/useSeries'
import * as S from './styled'
import type { Props } from './types'
import { getTableHeaders } from './utils'

export const SelectSeries = ({ selectedSeries, onConfirm, close }: Props) => {
  const [innerSelectedSeries, setInnerSelectedSeries] = useState(selectedSeries || [])
  const { seriesQuery, series } = useSeries()

  const handleCheckboxChange = (singleSeries: Series) => (value: boolean) => {
    if (value) {
      return setInnerSelectedSeries([
        {
          id: singleSeries.id,
        },
        ...innerSelectedSeries,
      ])
    }

    return setInnerSelectedSeries(
      filter(
        innerSelectedSeries,
        (selectedSingleSeries) => selectedSingleSeries.id !== singleSeries.id,
      ),
    )
  }

  const renderProducts = () => {
    return (
      <Table
        data={series || []}
        headers={getTableHeaders(innerSelectedSeries, handleCheckboxChange)}
        isLoading={seriesQuery.isLoading}
        minWidth={0}
      />
    )
  }

  const handleSubmitClick = () => {
    onConfirm(innerSelectedSeries)
    close()
  }

  return (
    <SelectModal
      title="Add this video to selected series"
      content={<S.TableContainer>{renderProducts()}</S.TableContainer>}
      message={`${innerSelectedSeries.length} series selected`}
      submitButtonLabel="Confirm"
      onSubmitClick={handleSubmitClick}
      close={close}
    />
  )
}
